import React, { useCallback } from 'react'
import styled from 'styled-components'
import SliderArrowsBig from '../../components/slider/SliderArrowsBig'
import Title from '../../components/Title'
import { useTranslation } from '../../store/hooks/dataHooks'
import { useApplication } from '../../store/hooks/uiInspirationHooks'
import { device } from '../../style'
import ModuleDetail from './../ModuleDetail'
import ModulesOverview from './../ModulesOverview'

const InspirationViewWrap = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 25px;

  @media ${device.tablet} {
    padding: 40px;
  }
`

const InspirationViewContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
  pointer-events: none;

  @media ${device.laptop} {
    flex-direction: row;
    justify-content: space-between;
  }
`

const LeftSide = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  ${Title} .teaser__content {
    padding: 0;
  }

  @media ${device.laptop} {
    padding: 25px;
  }
`

const LeftSideContent = styled.div`
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  @media ${device.tablet} {
    margin-bottom: 90px;
  }

  @media ${device.laptop} {
    max-width: 400px;
    max-height: none;
    justify-content: center;
    margin-bottom: 0px;
  }

  @media ${device.desktop} {
    max-width: 640px;
  }
`

const InspirationMode: React.FC = () => {
  const { currentApplication, previousApplication, nextApplication, gotoPrevious, gotoNext } = useApplication()

  const onKeyUp = useCallback(
    (e: React.KeyboardEvent<HTMLDivElement>) => {
      if (e.key === 'ArrowLeft') {
        gotoPrevious()
      }
      if (e.key === 'ArrowRight') {
        gotoNext()
      }
    },
    [gotoPrevious, gotoNext]
  )

  const t = useTranslation()

  return (
    <InspirationViewWrap tabIndex={0} onKeyUp={onKeyUp}>
      <InspirationViewContent>
        <LeftSide>
          <Title
            subline={
              <>
                Constela 19 LED
                <br />
                {t('headline.smartcity')}
              </>
            }
            white={true}
          >
            {currentApplication.title}
          </Title>
          <LeftSideContent>
            <ModulesOverview />
            <ModuleDetail />
          </LeftSideContent>
        </LeftSide>
      </InspirationViewContent>
      <SliderArrowsBig
        previous={previousApplication}
        next={nextApplication}
        onPrevious={gotoPrevious}
        onNext={gotoNext}
      />
    </InspirationViewWrap>
  )
}

export default InspirationMode
